import { Config, fetchJSON, Languages, PROVINCE } from '@ratehub/base-ui';
import { getSavingsProductShape } from '@ratehub/inv-common';


const API_ENDPOINT = `${Config.SAVINGS_API_URL}/accounts`;

async function fetchProductsForSavings(options) {
    const params = {
        language: options?.language ?? Languages.ENGLISH,
        province: options?.provinceCode ?? PROVINCE.ONTARIO,

        ...(!isNaN(options?.monthlyBalance) && {
            balance: Number(options.monthlyBalance),
        }),
        // for 'all' account types, simply omit accountType
        ...(options?.accountType && options.accountType !== 'all' && { type: options.accountType }),
        ...(options?.provider && { provider: options.provider }),
        ...(typeof options?.isPrioritizeSponsored === 'boolean' && {
            prioritizeSponsored: options.isPrioritizeSponsored,
        }),
        ...(options.customId && { customId: options.customId }),
    };

    const response = await fetchJSON(
        {
            url: API_ENDPOINT,
            options: {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params),
            },
        },
        'fetchProductsForSavingsV2',
    );

    return {
        lastUpdated: response.data?.lastUpdated,
        products: response.data?.products?.map((product) => 
            getSavingsProductShape(product, options?.accountType && options.accountType !== 'all'),
        ) || [],
    };
}

export default fetchProductsForSavings;
